module.exports = __webpack_public_path__ + "static/media/logo_with_text_black.dac797ab.png";